import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
// import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

class IdentifyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    };
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }
  onChangeCheckbox() {
    this.setState({
      isChecked: !this.state.isChecked
    });
  }

  render() {
    return (
      <EducationModuleLayout
        progressStage={5}
        childTitle="Identify"
        progressType="identify"
      >
        <section className="no-bottom-padding">
          <div className="container">
            <Row className="text-center">
              <Col md={12}>
                <h2 className="txt-purple no-bold">Behaviours, Thoughts and Feelings that Raises Specific Safety Concerns Requires Early Action </h2>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1}>
                <p>
                  Some indicators are particularly concerning and necessitate more immediately connecting the person you’re concerned about to
                  someone in a position to help. Specifically, behaviours, thoughts, and feelings that raise concerns about someone's safety
                should be treated with <strong>urgency</strong>.
              </p>
                <p>
                  These indicators can include the following:
              </p>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1}>
                <ul className="list-group">
                  <li className="list-group-item">
                    vague or overt references to harming self or others
                </li>
                  <li className="list-group-item">
                    vague or overt references to thoughts of suicide
                </li>
                  <li className="list-group-item">
                    confusion, disorientation, apparent disconnect from reality
                    (written or verbal)
                </li>
                  <li className="list-group-item">
                    expressions of hopelessness, helplessness, or worthlessness
                    (written or verbal)
                </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1}>
                <p>
                  Concerns about anyone's safety at any time should be treated with urgency and would require a more 
                  immediate connection or referral. As soon as you can, inform someone who is in a position to act. 
                  This can include contacting campus <a 
	    	      href="https://mentalhealth.utoronto.ca/find-support-and-services/" 
                      target="_blank"
                      rel="noopener noreferrer"
		  >mental health supports</a>, Campus Safety
                  or Emergency Services (9-1-1). In these situations, it’s important to do this even 
                  when the person you are concerned about is unwilling to access these resources themselves. 
                  Make sure to protect your own safety in the process.
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <div className="form-check" style={{ marginBottom: 20 }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="checkMark"
                    name="checkMark"
                    onChange={this.onChangeCheckbox}
                  />
                  <label className="form-check-label" htmlFor="checkMark">
                    Asking you to check this box is our way of drawing your attention
                    to just how important this message is. When you’re concerned that
                    there’s a risk to someone’s safety, a more immediate connection
                    is required.
                  </label>

                  {this.state.isChecked && (
                    <span style={{ fontSize: '30px' }} className="txt-green">
                      AWESOME!
                    </span>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={10} xsOffset={1}>
                <p>
                  It’s important to destigmatize and reshape beliefs connecting mental 
                  illness and violence. People with challenges to their mental health are 
                  no more likely to be violent than anyone else. In fact, people with severe 
                  mental illnesses are more likely to be victims of violence (Canadian Mental 
                  Health Association, 2020).
                  
                  Canadian Mental Health Association. (2020).<br />
                  <div>
                    <p>
                      Violence and mental health: Unpacking a complex issue, 
                    <a
                      href="https://ontario.cmha.ca/documents/violence-and-mental-health-unpacking-a-complex-issue/."
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://ontario.cmha.ca/documents/violence-and-mental-health-unpacking-a-complex-issue/.
                    </a>
                    </p>
                  </div>
                </p>
                <br />
              </Col>
            </Row>
          </div>
        </section>
        {this.state.isChecked && (
          <section>
            <div className="container text-center">
              <Row>
                <Col xs={12}>
                  <Button
                    className="btn btn-purple previous"
                    onClick={() => this.props.history.goBack()}
                  >
                    Previous
                  </Button>
                  <LinkContainer
                    to={url.IDENTIFY_F}
                    className="btn btn-purple next"
                  >
                    <Button>Next</Button>
                  </LinkContainer>
                </Col>
              </Row>
            </div>
          </section>
        )}
      </EducationModuleLayout>
    );
  }
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyB = IdentifyPage;
export default connect.role(IdentifyB);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyE/index.jsx